import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import {
  STAY_DURATION_COMMON,
  STAY_DURATION_US,
} from "@Pages/Search/components/FilterSection/data/filtersList";
import RadioChip from "../../../FilterSubsection/components/RadioChip";
import styles from "./stayDuration.module.scss";
import { FilterComponentProps } from "@Pages/Search/components/FilterSection/components/ActiveFilterComponent/types";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { COUNTRIES_WITH_MONTHLY_DURATION } from "constants/configConstants";

type StayDuration = (typeof STAY_DURATION_COMMON)[number]["name"];

const StayDuration = ({ value, dispatch }: FilterComponentProps<string>) => {
  const { country } = useSelector(
    ({ searchPageData, propertyPageData }: AppState) => ({
      country:
        searchPageData?.region?.location?.country?.short_name ||
        propertyPageData?.data?.location?.country?.short_name,
    }),
    shallowEqual,
  );

  const { t } = useTranslationHook();

  const leaseDurationTypes = COUNTRIES_WITH_MONTHLY_DURATION.includes(country)
    ? STAY_DURATION_US
    : STAY_DURATION_COMMON;

  let initialValue = "";
  if (value === "all_selected") {
    initialValue = "All";
  } else if (value) {
    initialValue =
      leaseDurationTypes.find((item) => item.value.includes(String(value)))?.name || "";
  }

  const [selectedDuration, setSelectedDuration] = useState<StayDuration>(
    initialValue?.trim() || "All",
  );

  const handleSelectedValue = (name = "", val = "") => {
    const [min, max] = val.split(",");
    setSelectedDuration(name);
    gtagEventEmitter({
      action: "SP_filter_subsection_filter2_value_selected",
      category: "SP_filter_subsection2",
      value: "Stay Duration",
    });

    if (name === "All") {
      dispatch({ type: "minLeaseDuration", payload: "all_selected" });
      dispatch({ type: "maxLeaseDuration", payload: "" });
    } else {
    dispatch({ type: "minLeaseDuration", payload: min });
    dispatch({ type: "maxLeaseDuration", payload: max });
    }
  };

  return (
    <div className={styles.stayDurationContainer}>
      {leaseDurationTypes.map(({ name, value: durationValue, key }) => (
        <RadioChip
          name="name"
          label={t(name)}
          value={durationValue}
          isSelected={selectedDuration === name}
          key={key}
          setSelectedValue={() => handleSelectedValue(name, durationValue)}
        />
      ))}
    </div>
  );
};
export default wrapperHOC(StayDuration, {
  componentName: "StayDuration-FilterSubsection2-SearchListDesktop-SearchPage",
  showForChina: true,
});
